var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{attrs:{"label":_vm.leadClassParam?.caption},model:{value:(_vm.param.value),callback:function ($$v) {_vm.$set(_vm.param, "value", _vm._n($$v))},expression:"param.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }